<mat-drawer-container class="countable-drawer">

    <mat-drawer-content class="overflow-hidden">

        <div class="page-wraper balance-sheet-wrapper bg-gray-50">
            <div class="page-title-block workbook-title-block align-items-start">
                <div class="left-content title-block-left button-group flex-row header-actions">
                    <button mat-button mat-stroked-button color="dark" class="btn-medium-icon button-tooltip"
                            title="Collapse All"
                            (click)="isBalanceSheetExpanded=false;togglePannels('C');" *ngIf="isBalanceSheetExpanded">
                        <i class="fa-regular fa-arrow-up-right-and-arrow-down-left-from-center fs-3 text-primary"></i>
                    </button>
                    <button mat-button mat-stroked-button color="dark" class="btn-medium-icon button-tooltip"
                            title="Expand All"
                            (click)="isBalanceSheetExpanded=true;togglePannels('E');" *ngIf="!isBalanceSheetExpanded">
                        <i class="fa-regular fa-arrow-down-left-and-arrow-up-right-to-center fs-3 text-primary"></i>
                    </button>
                    <button mat-button mat-stroked-button color="dark" class="btn-medium-icon button-tooltip"
                            title="Refresh"
                            (click)="refreshBalanceSheet()"
                            [disabled]="(firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress) || shortCutMenuDetails.isenglock !== 0">
                        <i class="fa-regular fa-arrows-rotate"></i>
                    </button>
                </div>

                <div class="title-block-middle flexbox-column gap-0 flex-1 align-items-center text-center">
                    <h3 class="titile">{{ clientName }}</h3>
                    <h3 class="title">{{ headerNotesColumn1 }}</h3>
                    <ng-container *ngIf="!isSecondColumnClicked">
                        <h6 class="title hover-action d-flex flex-row align-items-center gap-8 text-center"
                            [ngClass]="{'ps-3': shortCutMenuDetails.isenglock == 0}" style="min-height:36px;">
              <span [ngClass]="{'ps-2': shortCutMenuDetails.isenglock == 0}">{{ headerNotesColumn2 }} {{
                      currentYear |
                              appCountableTimeZone:'MMMM d, yyyy':'UTC'
                  }}</span>
                            <ng-container *ngIf="acl?.hasEngViewEdit">
                                <button mat-button *ngIf="shortCutMenuDetails.isenglock == 0 && !isHideActionsForPY"
                                        class="button-medium-icon hover-action-item"
                                        (click)="focusInput();isSecondColumnClicked = true; isThirdColumnClicked = false; isOldSecondColumn = headerNotesColumn2">
                                    <i class="fa-regular fa-pen fs-15"></i>
                                </button>
                            </ng-container>
                        </h6>
                    </ng-container>
                    <ng-container *ngIf="isSecondColumnClicked">
                        <mat-form-field class="fixed-label icon-form-after action-2 form-field-medium"
                                        style="width: 300px">
                            <input matInput [(ngModel)]="headerNotesColumn2" type="text" #focusInputField
                                   (click)="$event.stopPropagation();">
                            <div matSuffix class="actions border-start">
                                <button mat-button color="success"
                                        [disabled]="!acl?.hasEngViewEdit || !(headerNotesColumn2.trim())"
                                        [ngClass]="[!(headerNotesColumn2.trim()) ? 'btn-disabled' : '']"
                                        (click)="saveHeaderNote()">
                                    <i class="fa-regular fa-check"></i>
                                </button>
                                <button mat-button color="cancel"
                                        (click)="isSecondColumnClicked = false; headerNotesColumn2 = isOldSecondColumn">
                                    <i class="fa-regular fa-xmark clear-icon"></i>
                                </button>
                            </div>
                        </mat-form-field>
                        <h6 class="title">{{ currentYear | appCountableTimeZone:'MMMM d, yyyy':'UTC' }}</h6>
                    </ng-container>
                </div>

                <div class="title-block-right d-none d-lg-flex"></div>
            </div>

      <mat-accordion>
        <mat-expansion-panel class="plan-expansion body-expansion" expanded="true">
            <mat-expansion-panel-header class="d-block d-lg-none filter-actions-button">
                <mat-panel-title>
                        <div class="plan-expansion-header">
                            <button mat-button mat-stroked-button color="dark" class="button-default">
                                <span class="flexbox-row gap-8 flex-nowrap">
                                    <span class="title">Actions</span>
                                    <span class="toggle-icon dot-16 bg-transparent"></span>
                                </span>
                            </button>
                        </div>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="plan-expansion-body">
                <div class="sorting-block d-flex flex-row align-items-end justify-content-between p-24 flex-wrap gap-20">
                  <div class="sorting-block-left d-flex flex-row align-items-end gap-8 flex-1">
                    <mat-form-field class="form-item fixed-label" flex-1 floatLabel="always" style="max-width:300px;width:auto;" title="{{clientName}}">
                      <mat-label>Entity Name</mat-label>
                      <mat-select placeholder="Select entity" [(value)]="clientName" [disabled]=true title="{{clientName}}">
                        <mat-option value="{{clientName}}">
                          {{clientName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div class="form-item ng-form-field">
                        <label>Year End Date</label>
                      <ng-select placeholder="" [items]="yearEndDetails" [clearable]="false" [clearOnBackspace]="false"
                        bindValue="acctyear" bindLabel="acctdate" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedYearEnd" [title]="currentYear | appCountableTimeZone: 'MMM d, y':'UTC'" (change)="refreshBalanceSheet()">
                        <ng-template ng-option-tmp ng-label-tmp let-item="item">
                          {{ item.acctdate | appCountableTimeZone: 'MMM d, y':'UTC'}}
                       </ng-template>
                      </ng-select>
                    </div>
                  </div>

                            <form class="sorting-block-right d-flex flex-row gap-8">
                                <mat-form-field class="fixed-label label-none icon-field-before" floatLabel="always">
                                    <mat-label>Search</mat-label>
                                    <input matInput placeholder="Search" maxlength="20" size="20" #searchField
                                           placeholder="Search"
                                           [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}"
                                           (keyup)="handleSearch($event.target.value)" autocomplete="off">
                                    <span matPrefix>
                    <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                  </span>
                                </mat-form-field>
                            </form>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>

            <div class="content-block-main overflow-hidden template-block-main">
                <div class="balance-sheet-container-body-grid card h-100 overflow-auto w-100 auto-scroll-container"
                     [ngClass]="{'fixed-footer-enabled':isMove, 'notes-row': isHideNotesToFS}" cdkScrollable id="grid">
                    <div class="flex-table fixed-header hover-action leadsheet-grouping-table">
                        <div class="flex-table-header fixed-top" appSpin [spinnerConfig]='spinnerConfig()'
                             [ngClass]="{'showcolumns':isDisplayCol, 'notes-column':isHideNotesToFS}">
                            <div class="flexbox-row gap-0 flex-1 table-left-section align-items-stretch">
                                <p class="ft-header-cell col-status"></p>
                                <p class="ft-header-cell col-group flex-1">
                                    <span class="ps-1">Group Name</span>
                                </p>
                            </div>
                            <p class="ft-header-cell col-leadsheet border-start">LS</p>
                            <p class="ft-header-cell col-map">Map No.</p>
                            <p class="ft-header-cell col-nfs border-start" *ngIf="isHideNotesToFS">
                                <span>Notes to FS</span>
                            </p>
                            <p class="ft-header-cell col-current flex-column gap-0 align-items-end border-start"
                               title="{{currentYear | appCountableTimeZone:'MMMM d yyyy':'UTC'}}">
                                <span>{{ currentYear | appCountableTimeZone:'MMMM d':'UTC' }}</span>
                                <span>{{ currentYear | appCountableTimeZone:'yyyy':'UTC' }}</span>
                            </p>
                            <ng-container *ngIf="isDisplayCol">
                                <p class="ft-header-cell col-leadsheet border-start">LS</p>
                                <p class="ft-header-cell col-map border-end">Map No.</p>
                            </ng-container>

                            <p class="ft-header-cell col-previous flexbox-row gap-8 flex-nowrap pe-2" *ngIf="isPrevyear"
                               [ngClass]="{'border-start':!isDisplayCol}">
                                <button mat-button class="button-text" (click)="isPreviousYr()">
                                    <i class="fa-solid fa-plus add-icn-btn-pre"
                                       *ngIf="!isDisplayCol && !isHideActionsForPY"></i>
                                    <i class="fa-solid fa-minus add-icn-btn-pre" *ngIf="isDisplayCol"></i>
                                </button>
                                <span class="flexbox-column gap-0 align-items-end"
                                      title="{{previousYear | appCountableTimeZone:'MMMM d yyyy':'UTC'}}">
                                <span>{{ previousYear | appCountableTimeZone:'MMMM d':'UTC' }}</span>
                                <span>{{ previousYear | appCountableTimeZone:'yyyy':'UTC' }}</span>
                                </span>
                            </p>
                        </div>

                        <div class="balance-sheet-content"
                             [ngClass]="{'showcolumns':isDisplayCol, 'notes-column':isHideNotesToFS}">
                            <mat-accordion cdkDropListGroup #accordion="matAccordion" multi="true">
                                <!-- Group start -->
                                <ng-container
                                        *ngFor="let balancesheetData of balanceSheetDetails; trackBy: trackByRecords;">
                                    <mat-expansion-panel (keydown.Space)="$event.stopImmediatePropagation();"
                                                         [expanded]="isSearchExist ?balancesheetData.isexpand : isBalanceSheetExpanded"
                                                         *ngIf="balancesheetData.id!=4 && balancesheetData.id!=6"
                                                         (opened)="balancesheetData.id == 1 ?isOutsidePanel = false:'';balancesheetData.id == 5 ?isUnmappedLastIndex = false:'';balancesheetData.id == 3 ? isTotalLiabilityandEquityBorder = false:''"
                                                         (closed)="balancesheetData.id == 1 ?isOutsidePanel = true:'';balancesheetData.id == 5 ?isUnmappedLastIndex = true:'';balancesheetData.id == 3 ? isTotalLiabilityandEquityBorder = true:''"
                                                         #chapterExpansionPanel
                                                         (mouseenter)="mouseEnterHandler($event, chapterExpansionPanel)"
                                                         class="exp-one"
                                                         [ngStyle]="{'border-bottom': balancesheetData.id == 5 && isUnmappedLastIndex ? '1px solid #000':''}">
                                        <!--- first parent lead asheet group-->
                                        <mat-expansion-panel-header class="first-header"
                                                                    (keydown.Space)="$event.stopImmediatePropagation();">
                                            <mat-panel-title (keydown.Space)="$event.stopImmediatePropagation();">
                                                <div class="flex-table-header">
                                                    <div class="ft-row">
                                                        <div class="flexbox-row gap-0 flex-1 table-left-section align-items-stretch">
                                                            <div class="ft-cell col-toogle">
                                <span class="togglable-icon">
                                  <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                </span>
                                                            </div>
                                                            <p class="ft-cell col-header-title py-0 flexbox-row gap-8"
                                                               (click)="$event.stopPropagation()">
                                                                <ng-container
                                                                        *ngIf="balancesheetData.id != 5 else unmappedGroupName">
                                                                    <ng-container *ngIf="!balancesheetData.isEditable">
                                    <span class="text-ellipse fw-semibold" title="{{balancesheetData.name}}">
                                      {{ balancesheetData.name }}
                                    </span>
                                                                        <ng-container *ngIf="acl?.hasEngViewEdit">
                                                                            <button mat-button
                                                                                    class="button-text hover-action-item"
                                                                                    *ngIf="shortCutMenuDetails.isenglock == 0 && !isHideActionsForPY"
                                                                                    (click)="balancesheetData.oldvalue = balancesheetData.name;acticeGroup(balancesheetData, 'CHILD')">
                                                                                <i class="fa-regular fa-pen fs-15"></i>
                                                                            </button>
                                                                        </ng-container>
                                                                    </ng-container>

                                                                    <ng-container *ngIf="balancesheetData.isEditable">
                                                                        <mat-form-field
                                                                                class="fixed-label icon-form-after action-2 w-100 form-field-smaller">
                                                                            <input matInput type="text"
                                                                                   [(ngModel)]="balancesheetData.name"
                                                                                   #focusInputField
                                                                                   required>
                                                                            <div matSuffix class="actions border-start">
                                                                                <button mat-button color="success"
                                                                                        title="Save"
                                                                                        [disabled]="!(balancesheetData.name.trim())"
                                                                                        [ngClass]="[!(balancesheetData.name.trim()) ? 'btn-disabled' : '']"
                                                                                        (click)="balancesheetData.isEditable=!balancesheetData.isEditable;UpdateBalanceSheet(balancesheetData, 'PARENT')">
                                                                                    <i class="fa-regular fa-check"></i>
                                                                                </button>
                                                                                <button mat-button color="error"
                                                                                        title="Cancel"
                                                                                        (click)="balancesheetData.isEditable=!balancesheetData.isEditable;balancesheetData.name=balancesheetData.oldvalue; clearGroup()">
                                                                                    <i class="fa-regular fa-xmark clear-icon"></i>
                                                                                </button>
                                                                            </div>
                                                                        </mat-form-field>
                                                                    </ng-container>
                                                                </ng-container>

                                                                <ng-template #unmappedGroupName>
                                  <span class="text-ellipse fw-semibold" title="{{balancesheetData.name}}">
                                    {{ balancesheetData.name }}
                                  </span>
                                                                </ng-template>
                                                            </p>
                                                        </div>

                                                        <p class="ft-cell col-leadsheet border-start"></p>
                                                        <p class="ft-cell col-map"></p>
                                                        <p class="ft-cell col-nfs border-start"
                                                           *ngIf="isHideNotesToFS"></p>
                                                        <p class="ft-cell col-current text-end fw-semibold border-start"
                                                           [ngClass]="{'showcolumns':isDisplayCol}">
                              <span class="text-ellipse totalValue"
                                    *ngIf="!balancesheetData.isexpand || !balancesheetData.isHideTotal">
                                {{ balancesheetData.Currgrouptotal }}
                              </span>
                                                        </p>
                                                        <ng-container *ngIf="isDisplayCol">
                                                            <p class="ft-cell col-leadsheet border-start"></p>
                                                            <p class="ft-cell col-map border-end"></p>
                                                        </ng-container>
                                                        <p class="ft-cell col-previous text-end fw-semibold pe-2"
                                                           *ngIf="isPrevyear"
                                                           [ngClass]="{'border-start':!isDisplayCol}">
                              <span class="text-ellipse totalValue"
                                    *ngIf="!balancesheetData.isexpand || !balancesheetData.isHideTotal">
                                {{ balancesheetData.Prevgrouptotal }}
                              </span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>

                                        <!-- Sub group start -->
                                        <ng-container
                                                *ngFor="let lSgroupchild of balancesheetData.children; index as c; last as subLastIndex; trackBy: trackByChildRecords;">
                                            <mat-expansion-panel
                                                    [expanded]="isSearchExist ? lSgroupchild.isexpand : isBalanceSheetExpanded"
                                                    *ngIf="balancesheetData.id!=5" class="secondary-exp"
                                                    #chapterExpansionPanel
                                                    (mouseenter)="mouseEnterHandler($event, chapterExpansionPanel)"
                                                    (keydown.Space)="$event.stopImmediatePropagation();"
                                                    (opened)="isSubLastIndex = false"
                                                    (closed)="isSubLastIndex = true"
                                                    [ngStyle]="{'border-bottom': subLastIndex && isSubLastIndex ? '1px solid #000':''}">
                                                <mat-expansion-panel-header class="second-header"
                                                                            (keydown.Space)="$event.stopImmediatePropagation();">
                                                    <mat-panel-title
                                                            (keydown.Space)="$event.stopImmediatePropagation();">

                                                        <div class="flex-table-header">
                                                            <div class="flexbox-row gap-0 flex-1 table-left-section align-items-stretch">
                                                                <div class="ft-cell col-toogle">
                                  <span class="togglable-icon">
                                    <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                  </span>
                                                                </div>
                                                                <p class="ft-cell col-header-title py-0 flexbox-row gap-8"
                                                                   (click)="$event.stopPropagation()">
                                                                    <ng-container *ngIf="!lSgroupchild.isEditable">
                                    <span class="text-ellipse fw-semibold flexbox-row gap-8"
                                          title="{{lSgroupchild.name}}">
                                      {{ lSgroupchild.name }}
                                    </span>
                                      <ng-container *ngIf="acl?.hasEngViewEdit">
                                      <button mat-button class="button-text hover-action-item"
                                        *ngIf="shortCutMenuDetails.isenglock == 0 && !isHideActionsForPY"
                                        (click)="lSgroupchild.oldvalue = lSgroupchild.name;acticeGroup(lSgroupchild, 'CHILD')">
                                        <i class="fa-regular fa-pen fs-15"></i>
                                      </button>
                                    </ng-container>
                                    <!-- Sub Group sorting start -->
                                      <ng-container *ngIf="acl?.hasEngViewEdit && !isHideActionsForPY">
                                      <button mat-button class="button-text hover-action-item"
                                        (click)="getSubGroupSortingData(lSgroupchild, $event, false)"
                                        *ngIf="shortCutMenuDetails.isenglock == 0">
                                        <i class="fa-solid fa-arrow-up-long fs-15"></i>
                                      </button>
                                    </ng-container>
                                    <!-- Sub Group sorting end -->
                                    <ng-container *ngIf="lSgroupchild.isuseradded == 1">
                                        <ng-container *ngIf="acl?.hasEngViewEdit">
                                        <button mat-button class="button-text hover-action-item" (click)="unGroup()"
                                          *ngIf="shortCutMenuDetails.isenglock == 0">
                                          <i class="fa-regular fa-puzzle fs-15"></i>
                                        </button>
                                      </ng-container>
                                    </ng-container>
                                  </ng-container>
                                  <ng-container *ngIf="lSgroupchild.isEditable">
                                    <mat-form-field class="fixed-label icon-form-after action-2 w-100 form-field-smaller">
                                      <input matInput type="text" [(ngModel)]="lSgroupchild.name" #focusInputField
                                        required>
                                      <div matSuffix class="actions border-start">
                                        <button mat-button color="success" title="Save" [disabled]="!(lSgroupchild.name.trim())" [ngClass]="[!(lSgroupchild.name.trim()) ? 'btn-disabled' : '']"
                                          (click)="lSgroupchild.isEditable=!lSgroupchild.isEditable;UpdateBalanceSheet(lSgroupchild, 'CHILD')">
                                          <i class="fa-regular fa-check"></i>
                                        </button>
                                        <button mat-button color="error" title="Cancel"
                                          (click)="lSgroupchild.isEditable=!lSgroupchild.isEditable;lSgroupchild.name=lSgroupchild.oldvalue;clearGroup()">
                                          <i class="fa-regular fa-xmark clear-icon"></i>
                                        </button>
                                      </div>
                                    </mat-form-field>
                                  </ng-container>
                                </p>
                              </div>
                              <p class="ft-cell col-leadsheet border-start"></p>
                              <p class="ft-cell col-map"></p>
                              <p class="ft-cell col-nfs border-start" *ngIf="isHideNotesToFS"></p>
                              <p class="ft-cell col-current text-end fw-semibold border-start"
                                [ngClass]="{'showcolumns':isDisplayCol}">
                                <span class="text-ellipse totalValue"
                                      *ngIf="!lSgroupchild.isexpand || !lSgroupchild.isHideTotal">
                                  {{ lSgroupchild.Currbal }}
                                </span>
                                                            </p>
                                                            <ng-container *ngIf="isDisplayCol">
                                                                <p class="ft-cell col-leadsheet border-start"></p>
                                                                <p class="ft-cell col-map border-end"></p>
                                                            </ng-container>
                                                            <p class="ft-cell col-previous text-end fw-semibold pe-2"
                                                               *ngIf="isPrevyear"
                                                               [ngClass]="{'border-start':!isDisplayCol}">
                                <span class="text-ellipse totalValue"
                                      *ngIf="!lSgroupchild.isexpand || !lSgroupchild.isHideTotal">
                                  {{ lSgroupchild.Prevbal }}
                                </span>
                                                            </p>
                                                        </div>
                                                    </mat-panel-title>
                                                </mat-expansion-panel-header>

                                                <!-- Sub group child start -->
                                                <ng-container
                                                        *ngFor="let child2 of lSgroupchild.children; index as i; last as lastIndex;  trackBy: trackByChild2Records;">
                                                    @if (child2?.is_schedule_exits && child2?.groupName) {
                                                        <mat-expansion-panel>
                                                            <mat-expansion-panel-header class="third-header"
                                                                                        (keydown.Space)="$event.stopImmediatePropagation();">
                                                                <mat-panel-title
                                                                        (keydown.Space)="$event.stopImmediatePropagation();">

                                                                    <div class="flex-table-header">
                                                                        <div class="flexbox-row gap-0 flex-1 table-left-section align-items-stretch">
                                                                            <div class="ft-cell col-toogle">
                                  <span class="togglable-icon">
                                    <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                  </span>
                                                                            </div>
                                                                            <p class="ft-cell col-header-title py-0 flexbox-row gap-8"
                                                                               (click)="$event.stopPropagation()">
                                                                               <mat-checkbox class="label-none"
                                                                              disabled></mat-checkbox>
                                                                                 <span class="text-ellipse fw-semibold flexbox-row gap-8"
                                                                                       title="{{child2?.groupName}}">
                                      {{ child2?.groupName }}
                                    </span>
                                                                                @if (child2?.is_schedule_exits) {
                                                                                    <button mat-button
                                                                                            mat-stroked-button
                                                                                            color="success"
                                                                                            class="btn-small schedule-success-btn"
                                                                                            (click)="selectedSchedule.set(child2)"
                                                                                            [matMenuTriggerFor]="scheduleOperation">
                                                                                        {{ child2?.schedule_name }}
                                                                                        <i class="fa-regular fa-angle-down"></i>
                                                                                    </button>
                                                                                }

                                                                            </p>
                                                                        </div>



                                                                    </div>
                                                                </mat-panel-title>
                                                            </mat-expansion-panel-header>
                                                            <ng-container
                                                                    *ngFor="let subChild of child2.children; index as subIndex; last as sublastIndex;  trackBy: trackByChild2Records;">
                                                                <div *ngTemplateOutlet="subGroupChildren; context: { child2: subChild, balancesheetData:balancesheetData, i:subIndex, lastIndex:sublastIndex, lSgroupchild: lSgroupchild , isSubGroup:true }"></div>
                                                            </ng-container>

                                                        </mat-expansion-panel>
                                                    } @else {
                                                        <div *ngTemplateOutlet="subGroupChildren; context: { child2: child2, balancesheetData:balancesheetData,i:i, lastIndex:lastIndex, lSgroupchild: lSgroupchild, isSubGroup:false }"></div>
                                                    }
                                                </ng-container>
                                                <!-- Sub group child end -->
                                                <!-- Sub group tatal start -->
                                                <div class="ft-row" [ngClass]="{'second-footer': subLastIndex !== c}">
                                                    <div class="flexbox-row gap-0 flex-1 table-left-section align-items-stretch">
                                                        <p class="ft-cell col-status"></p>
                                                        <p class="ft-cell col-drag-drop"></p>
                                                        <p class="ft-cell col-checkbox pe-0"></p>
                                                        <p class="ft-cell col-header-title py-0 flex-nowrap flexbox-row gap-8"
                                                           (click)="$event.stopPropagation()">
                              <span class="text-ellipse fw-semibold" title="{{lSgroupchild.totalname}}">
                                {{ lSgroupchild.totalname }}
                              </span>
                                                        </p>
                                                    </div>
                                                    <p class="ft-cell col-leadsheet border-start"></p>
                                                    <p class="ft-cell col-map"></p>
                                                    <p class="ft-cell col-nfs border-start" *ngIf="isHideNotesToFS"></p>
                                                    <p class="ft-cell col-current text-end fw-semibold border-let"
                                                       [ngClass]="{'showcolumns':isDisplayCol}">
                            <span class="text-ellipse" title="{{lSgroupchild.Currbal}}">
                              {{ lSgroupchild.Currbal }}
                            </span>
                                                    </p>
                                                    <ng-container *ngIf="isDisplayCol">
                                                        <p class="ft-cell col-leadsheet border-start"></p>
                                                        <p class="ft-cell col-map border-end"></p>
                                                    </ng-container>
                                                    <p class="ft-cell col-previous text-end fw-semibold pe-2"
                                                       *ngIf="isPrevyear"
                                                       [ngClass]="{'border-start':!isDisplayCol}">
                            <span class="text-ellipse" title="{{lSgroupchild.Prevbal}}">
                              {{ lSgroupchild.Prevbal }}
                            </span>
                                                    </p>
                                                </div>
                                                <!-- Sub group tatal end -->
                                            </mat-expansion-panel>
                                        </ng-container>
                                        <!-- Sub group end -->
                                        <!-- Unmapped records start -->
                                        <ng-container *ngIf="balancesheetData.id==5">
                                            <!--Unmapped-->
                                            <div class="unmapped-row" cdkDropList [cdkDropListConnectedTo]="connectedTo"
                                                 [cdkDropListData]="balancesheetData.children">
                                                <div class="ft-row"
                                                     *ngFor="let lSgroupchild of balancesheetData.children" cdkDrag
                                                     [cdkDragData]="lSgroupchild"
                                                     [cdkDragDisabled]="!acl?.hasEngViewEdit || selectedTrailBLrow.length > 1 || shortCutMenuDetails.isenglock != 0"
                                                     (mouseover)="lSgroupchild.selected = true"
                                                     (mouseout)="lSgroupchild.selected = false"
                                                     [ngStyle]="{cursor: selectedTrailBLrow.length > 1 || shortCutMenuDetails.isenglock == 0 || !acl?.hasEngViewEdit ? 'default': 'grab'}">
                                                    <div class="flexbox-row gap-0 flex-1 table-left-section align-items-stretch">
                                                        <p class="ft-cell col-status"></p>
                                                        <p class="ft-cell col-drag-drop"
                                                           [hidden]="shortCutMenuDetails.isenglock != 0">
                                                            <ng-container *ngIf="acl?.hasEngViewEdit">
                                                                <button mat-button
                                                                        class="button-text hover-action-item cursor-grab"
                                                                        *ngIf="lSgroupchild.selected && this.selectedTrailBLrow.length < 2">
                                                                    <i class="fa-solid fa-grip-dots-vertical"></i>
                                                                </button>
                                                            </ng-container>
                                                        </p>
                                                        <p class="ft-cell col-checkbox pe-0">
                                                            <ng-container
                                                                    *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showUnMapGrCheckbox">
                                                                <mat-checkbox class="label-none"
                                                                              disabled></mat-checkbox>
                                                            </ng-container>
                                                            <ng-template #showUnMapGrCheckbox>
                                                                <mat-checkbox class="label-none"
                                                                              [(ngModel)]="lSgroupchild.checked"
                                                                              (ngModelChange)="checkChange(lSgroupchild,'unmapped')"
                                                                              (click)="changeUnmappedPosition($event)">
                                                                </mat-checkbox>
                                                            </ng-template>
                                                        </p>
                                                        <p class="ft-cell col-header-title py-0 flex-nowrap flexbox-row gap-8">
                              <span class="text-ellipse" title="{{lSgroupchild.accountname}}">
                                {{ lSgroupchild.accountname }}
                              </span>
                                                        </p>
                                                    </div>

                                                    <p class="ft-cell col-leadsheet border-start"
                                                       title="{{lSgroupchild.leadsheet?lSgroupchild.leadsheet:'-'}}">
                                                        <span>{{ lSgroupchild.leadsheet ? lSgroupchild.leadsheet : '-' }}</span>
                                                    </p>
                                                    <p class="ft-cell col-map">
                                                        <ng-container
                                                                *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showlSgroupchildMap2Buttons">
                              <span title="{{lSgroupchild.mapno?lSgroupchild.mapno:'-'}}" class="text-ellipse">
                                {{ lSgroupchild.mapno ? lSgroupchild.mapno : '-' }}
                              </span>
                                                        </ng-container>

                                                        <ng-template #showlSgroupchildMap2Buttons>
                                                            <button mat-button class="button-text text-left w-100"
                                                                    title="{{lSgroupchild.mapno?lSgroupchild.mapno:'-'}}"
                                                                    (click)="activeUnmappedMapDropdown(lSgroupchild);"
                                                                    [matMenuTriggerFor]="unmappedMapId"
                                                                    [disabled]="!isindividualRowSave">
                                <span
                                        class="text-ellipse text-link">{{ lSgroupchild.mapno ? lSgroupchild.mapno : '-' }}</span>
                                                                <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                                                            </button>
                                                            <!-- <span [matMenuTriggerFor]="unmappedMapId" #unMappedMapMenu="matMenuTrigger"></span> -->
                                                            <mat-menu #unmappedMapId="matMenu" class="map-menu"
                                                                      #beforeMenu="matMenu"
                                                                      xPosition="before">
                                                                <ng-container
                                                                        *ngIf="lSgroupchild.isMap && isindividualRowSave">
                                                                    <map-dropdown [tbMapsheetId]="tbMapSheetId"
                                                                                  [parentObject]="lSgroupchild"
                                                                                  [moveType]="'SINGLE'"
                                                                                  [yearType]="CURRENT"
                                                                                  [yearEnd]="selectedYearEnd"
                                                                                  [subscribeFrom]="'BS'"></map-dropdown>
                                                                </ng-container>
                                                            </mat-menu>
                                                        </ng-template>
                                                    </p>
                                                    <p class="ft-cell col-nfs border-start" *ngIf="isHideNotesToFS"></p>
                                                    <p class="ft-cell col-current text-end border-start"
                                                       title="{{lSgroupchild.Currbal}}">
                            <span class="text-ellipse">
                              {{ lSgroupchild.Currbal }}
                            </span>
                                                    </p>
                                                    <ng-container *ngIf="isDisplayCol">
                                                        <p class="ft-cell col-leadsheet border-start">
                                                            <span class="text-ellipse">-</span>
                                                        </p>
                                                        <p class="ft-cell col-map border-end">
                                                            <ng-container
                                                                    *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showlSgroupchildMapButtons">
                                <span title="{{lSgroupchild.mapno?lSgroupchild.mapno:'-'}}" class="text-ellipse">
                                  {{ lSgroupchild.mapno ? lSgroupchild.mapno : '-' }}
                                </span>
                                                            </ng-container>

                                                            <ng-template #showlSgroupchildMapButtons>
                                                                <button mat-button title="-"
                                                                        class="button-text w-100 text-left"
                                                                        (click)="activeUnmappedMapDropdown(lSgroupchild);"
                                                                        [matMenuTriggerFor]="unmappedMapId"
                                                                        [disabled]="!isindividualRowSave">
                                  <span
                                          class="text-ellipse text-link">{{ lSgroupchild.mapno ? lSgroupchild.mapno : '-' }}</span>
                                                                    <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                                                                </button>
                                                                <!-- <span [matMenuTriggerFor]="unmappedMapId" #unMappedMapMenu="matMenuTrigger"></span> -->
                                                                <mat-menu #unmappedMapId="matMenu" class="map-menu"
                                                                          #beforeMenu="matMenu"
                                                                          xPosition="before">
                                                                    <ng-container
                                                                            *ngIf="lSgroupchild.isMap && isindividualRowSave">
                                                                        <map-dropdown [tbMapsheetId]="tbMapSheetId"
                                                                                      [parentObject]="lSgroupchild"
                                                                                      [moveType]="'SINGLE'"
                                                                                      [yearType]="PREVIOUS"
                                                                                      [yearEnd]="selectedYearEnd"
                                                                                      [subscribeFrom]="'BS'"></map-dropdown>
                                                                    </ng-container>
                                                                </mat-menu>
                                                            </ng-template>
                                                        </p>
                                                    </ng-container>

                                                    <p class="ft-cell col-previous text-end"
                                                       [ngClass]="{'border-start':!isDisplayCol}"
                                                       title="{{lSgroupchild.Prevbal}}" *ngIf="isPrevyear">
                            <span class="text-ellipse">
                              {{ lSgroupchild.Prevbal }}
                            </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <!-- Unmapped records end -->
                                        <!-- Main group total start -->
                                        <div class="ft-row"
                                             [ngStyle]="{'border-top': balancesheetData.id == 5 ? '1px solid #000':''}">

                                            <div class="flexbox-row gap-0 flex-1 table-left-section align-items-stretch">
                                                <p class="ft-cell col-status"></p>
                                                <p class="ft-cell col-drag-drop"></p>
                                                <p class="ft-cell col-checkbox pe-0"></p>
                                                <p class="ft-cell col-header-title py-0 flex-nowrap flexbox-row gap-8">
                                                    <ng-container
                                                            *ngIf="balancesheetData.id == 1 else unmappedTotalGroupName">
                                                        <ng-container *ngIf="!balancesheetData.isTotalEditable">
                              <span class="text-ellipse fw-semibold" title="{{balancesheetData.totalname}}">
                                {{ balancesheetData.totalname }}
                              </span>

                                                            <ng-container *ngIf="acl?.hasEngViewEdit">
                                                                <button mat-button class="button-text ms-2"
                                                                        *ngIf="shortCutMenuDetails.isenglock == 0 && !isHideActionsForPY"
                                                                        (click)="balancesheetData.oldtotalname = balancesheetData.totalname;acticeGroup(balancesheetData, 'PARENT')">
                                                                    <i class="fa-regular fa-pen fs-15"></i>
                                                                </button>
                                                            </ng-container>
                                                        </ng-container>
                                                        <!-- <ng-container *ngIf="balancesheetData.isTotalEditable"> -->
                                                        <ng-container *ngIf="balancesheetData.isTotalEditable">
                                                            <mat-form-field
                                                                    class="mat-form-item fixed-label icon-form-after input-fields-item action-2 form-field-smaller"
                                                                    floatLabel="always">
                                                                <input matInput type="text"
                                                                       [(ngModel)]="balancesheetData.totalname"
                                                                       #focusInputField
                                                                       required/>
                                                                <div matSuffix class="actions border-start">
                                                                    <button mat-button color="success" title="Save"
                                                                            [disabled]="!(balancesheetData.totalname.trim())"
                                                                            [ngClass]="[!(balancesheetData.totalname.trim()) ? 'btn-disabled' : '']"
                                                                            (click)="balancesheetData.isTotalEditable=!balancesheetData.isTotalEditable;UpdateBalanceSheet(balancesheetData, 'PARENT')">
                                                                        <i class="fa-regular fa-check"></i>
                                                                    </button>
                                                                    <button mat-button color="error" title="Cancel"
                                                                            (click)="balancesheetData.isTotalEditable=!balancesheetData.isTotalEditable;balancesheetData.totalname=balancesheetData.oldtotalname;clearGroup()">
                                                                        <i class="fa-regular fa-xmark clear-icon"></i>
                                                                    </button>
                                                                </div>
                                                            </mat-form-field>
                                                        </ng-container>
                                                    </ng-container>
                                                    <!-- </ng-container> -->
                                                    <ng-template #unmappedTotalGroupName>
                            <span class="ellipse no-marg edit-item fw-semibold" title="{{balancesheetData.totalname}}">
                              {{ balancesheetData.totalname }}
                            </span>
                                                    </ng-template>
                                                </p>
                                            </div>
                                            <p class="ft-cell col-leadsheet border-start"></p>
                                            <p class="ft-cell col-map"></p>
                                            <p class="ft-cell col-nfs border-start" *ngIf="isHideNotesToFS"></p>
                                            <p class="ft-cell col-current text-end fw-semibold border-start"
                                               [ngClass]="{'showcolumns':isDisplayCol}">
                        <span class="text-ellipse" title="{{balancesheetData.Currgrouptotal}}">
                          {{ balancesheetData.Currgrouptotal }}
                        </span>
                                            </p>
                                            <ng-container *ngIf="isDisplayCol">
                                                <p class="ft-cell col-leadsheet border-start"></p>
                                                <p class="ft-cell col-map border-end"></p>
                                            </ng-container>
                                            <p class="ft-cell col-previous text-end fw-semibold pe-2" *ngIf="isPrevyear"
                                               [ngClass]="{'border-start':!isDisplayCol}">
                        <span class="text-ellipse" title="{{balancesheetData.Prevgrouptotal}}">
                          {{ balancesheetData.Prevgrouptotal }}
                        </span>
                                            </p>
                                        </div>
                                        <!-- Main group total end -->
                                    </mat-expansion-panel>
                                    <!-- Main group total in outside panel start -->
                                    <div class="ft-row main-out-footer"
                                         *ngIf="isOutsidePanel && balancesheetData.id == 1">
                                        <div class="flexbox-row gap-0 flex-1 table-left-section align-items-stretch">
                                            <p class="ft-cell col-status"></p>
                                            <p class="ft-cell col-header-title py-0 flexbox-row gap-8">
                                                <ng-container *ngIf="!balancesheetData.isTotalEditable">
                          <span class="text-ellipse fw-semibold ps-1" title="{{balancesheetData.totalname}}">
                            {{ balancesheetData.totalname }}
                          </span>
                                                    <button mat-button class="button-text hover-action-item"
                                                            *ngIf="acl?.hasEngViewEdit && !isHideActionsForPY"
                                                            (click)="balancesheetData.oldtotalname = balancesheetData.totalname;acticeGroup(balancesheetData, 'PARENT')">
                                                        <i class="fa-regular fa-pen fs-15"></i>
                                                    </button>
                                                </ng-container>

                                                <ng-container *ngIf="balancesheetData.isTotalEditable">
                                                    <ng-container *ngIf="balancesheetData.isTotalEditable">
                                                        <mat-form-field
                                                                class="fixed-label label-none icon-form-after action-2 form-field-smaller"
                                                                floatLabel="always">
                                                            <mat-label>Value</mat-label>
                                                            <input matInput type="text"
                                                                   [(ngModel)]="balancesheetData.totalname"
                                                                   #focusInputField
                                                                   required>
                                                            <div matSuffix class="actions border-start">
                                                                <button mat-button color="success" title="Update"
                                                                        [disabled]="!(balancesheetData.totalname.trim())"
                                                                        [ngClass]="[!(balancesheetData.totalname.trim()) ? 'btn-disabled' : '']"
                                                                        (click)="balancesheetData.isTotalEditable=!balancesheetData.isTotalEditable;UpdateBalanceSheet(balancesheetData, 'PARENT')">
                                                                    <i class="fa-regular fa-check"></i>
                                                                </button>
                                                                <button mat-button color="error" title="Cancel"
                                                                        (click)="balancesheetData.isTotalEditable=!balancesheetData.isTotalEditable;balancesheetData.totalname=balancesheetData.oldtotalname;clearGroup()">
                                                                    <i class="fa-regular fa-xmark clear-icon"></i>
                                                                </button>
                                                            </div>
                                                        </mat-form-field>
                                                    </ng-container>
                                                </ng-container>
                                            </p>
                                        </div>
                                        <p class="ft-cell col-leadsheet border-start"></p>
                                        <p class="ft-cell col-map"></p>
                                        <p class="ft-cell col-nfs border-start" *ngIf="isHideNotesToFS"></p>
                                        <p class="ft-cell col-current text-end fw-semibold border-start"
                                           [ngClass]="{'showcolumns':isDisplayCol}">
                      <span class="text-ellipse" title="{{balancesheetData.Currgrouptotal}}">
                        {{ balancesheetData.Currgrouptotal }}
                      </span>
                                        </p>
                                        <ng-container *ngIf="isDisplayCol">
                                            <p class="ft-cell col-leadsheet border-start"></p>
                                            <p class="ft-cell col-map border-end"></p>
                                        </ng-container>
                                        <p class="ft-cell col-previous text-end fw-semibold pe-2" *ngIf="isPrevyear"
                                           [ngClass]="{'border-start':!isDisplayCol}">
                      <span class="text-ellipse" title="{{balancesheetData.Prevgrouptotal}}">
                        {{ balancesheetData.Prevgrouptotal }}
                      </span>
                                        </p>
                                    </div>
                                    <!-- Main group total  in outside panel end -->


                                    <!-- Total liabilities and Equity start -->
                                    <ng-container *ngIf="balancesheetData.id==4">
                                        <div class="ft-row">
                                            <div class="flexbox-row gap-0 flex-1 table-left-section align-items-stretch">
                                                <p class="ft-cell col-status"></p>
                                                <p class="ft-cell col-header-title py-0 flexbox-row gap-8">
                                                    <ng-container *ngIf="!balancesheetData.isEditable">
                                                        <span class="text-ellipse fw-semibold ps-1">{{ balancesheetData.totalname }}</span>
                                                        <ng-container *ngIf="acl?.hasEngViewEdit">
                                                            <button mat-button class="button-text hover-action-item"
                                                                    *ngIf="shortCutMenuDetails.isenglock == 0 && !isHideActionsForPY"
                                                                    (click)="balancesheetData.oldtotalname = balancesheetData.totalname;acticeGroup(balancesheetData, 'CHILD')">
                                                                <i class="fa-regular fa-pen fs-15"></i>
                                                            </button>
                                                        </ng-container>
                                                    </ng-container>
                                                    <ng-container *ngIf="balancesheetData.isEditable">
                                                        <mat-form-field
                                                                class="mat-form-item fixed-label icon-form-after input-fields-item action-2 form-field-smaller"
                                                                floatLabel="always">
                                                            <input matInput type="text"
                                                                   [(ngModel)]="balancesheetData.totalname"
                                                                   #focusInputField
                                                                   required>
                                                            <div matSuffix class="actions border-start">
                                                                <button mat-button color="success" title="Save"
                                                                        [disabled]="!(balancesheetData.totalname.trim())"
                                                                        [ngClass]="[!(balancesheetData.totalname.trim()) ? 'btn-disabled' : '']"
                                                                        (click)="balancesheetData.isEditable=!balancesheetData.isEditable;UpdateBalanceSheet(balancesheetData, 'PARENT')">
                                                                    <i class="fa-regular fa-check"></i>
                                                                </button>
                                                                <button mat-button color="error" title="Cancel"
                                                                        (click)="balancesheetData.isEditable=!balancesheetData.isEditable;balancesheetData.totalname=balancesheetData.oldtotalname;clearGroup()">
                                                                    <i class="fa-regular fa-xmark clear-icon"></i>
                                                                </button>
                                                            </div>
                                                        </mat-form-field>
                                                    </ng-container>
                                                </p>
                                            </div>
                                            <p class="ft-cell col-leadsheet border-start"></p>
                                            <p class="ft-cell col-map"></p>
                                            <p class="ft-cell col-nfs border-start" *ngIf="isHideNotesToFS"></p>
                                            <p class="ft-cell col-current text-end fw-semibold border-start"
                                               [ngClass]="{'showcolumns':isDisplayCol}">
                        <span class="text-ellipse" title="{{balancesheetData.Currgrouptotal}}">
                          {{ balancesheetData.Currgrouptotal }}
                        </span>
                                            </p>
                                            <ng-container *ngIf="isDisplayCol">
                                                <p class="ft-cell col-leadsheet border-start"></p>
                                                <p class="ft-cell col-map border-end"></p>
                                            </ng-container>
                                            <p class="ft-cell col-previous text-end fw-semibold pe-2" *ngIf="isPrevyear"
                                               [ngClass]="{'border-start':!isDisplayCol}">
                        <span class="text-ellipse" title="{{balancesheetData.Prevgrouptotal}}">
                          {{ balancesheetData.Prevgrouptotal }}
                        </span>
                                            </p>
                                        </div>
                                    </ng-container>
                                    <!-- Total liabilities and Equity end -->
                                    <!-- Main total start -->
                                    <ng-container *ngIf="balancesheetData.id==6">
                                        <div class="ft-row" [ngClass]="{'final-footer': unmappedArray.length > 0}">
                                            <div class="flexbox-row gap-0 flex-1 table-left-section align-items-stretch">
                                                <p class="ft-cell col-status"></p>
                                                <p class="ft-cell col-drag-drop"></p>
                                                <p class="ft-cell col-checkbox pe-0"></p>
                                                <p class="ft-cell col-header-title py-0 flex-nowrap gap-8"></p>
                                            </div>
                                            <p class="ft-cell col-leadsheet border-start"></p>
                                            <p class="ft-cell col-map"></p>
                                            <p class="ft-cell col-nfs" *ngIf="isHideNotesToFS"></p>
                                            <p class="ft-cell col-current text-end fw-semibold"
                                               [ngClass]="{'showcolumns':isDisplayCol, 'text-error': balancesheetData.Currgrouptotal != '-', 'col-left-no-border': unmappedArray.length == 0}">
                        <span class="text-ellipse" title="{{balancesheetData.Currgrouptotal}}">
                          {{ balancesheetData.Currgrouptotal }}
                        </span>
                                            </p>
                                            <ng-container *ngIf="isDisplayCol">
                                                <p class="ft-cell col-leadsheet border-start"></p>
                                                <p class="ft-cell col-map border-end"></p>
                                            </ng-container>
                                            <p class="ft-cell col-previous text-end fw-semibold pe-2" *ngIf="isPrevyear"
                                               [ngClass]="{'text-error': balancesheetData.Prevgrouptotal != '-', 'border-start': !isDisplayCol && unmappedArray.length > 0}">
                        <span class="text-ellipse" title="{{balancesheetData.Prevgrouptotal}}">
                          {{ balancesheetData.Prevgrouptotal }}
                        </span>
                                            </p>
                                        </div>
                                    </ng-container>
                                    <!-- Main total end -->
                                </ng-container>
                                <!-- Group end -->
                            </mat-accordion>
                        </div>
                    </div>
                </div>
            </div>

      <div class="bs-footer" *ngIf="isHideFooterNotesToFS">
        <ng-container *ngIf="!isFooterNoteEdited">
          <p class="bs-footer-text hover-action">
            {{footerNotes}}
            <button mat-button class="button-text hover-action-item" (click)="editFooterNotes();"
            *ngIf="!isHideActionsForPY">
                <i class="fa-regular fa-pen fs-15"></i>
            </button>
          </p>

                </ng-container>
                <ng-container *ngIf="isFooterNoteEdited">
                    <div class="footer-input flex-box-col">
                        <div class="pc-add-col">
                            <mat-form-field class="mat-form-item fixed-label icon-form-after input-fields-item action-2"
                                            floatLabel="always">
                                <input matInput type="text" class="" [(ngModel)]="footerNote" #focusInputField>
                                <div matSuffix class="actions border-start">
                                    <button mat-button color="success" title="Save" (click)="saveFooterNote()"
                                            [disabled]="!(footerNote.trim())">
                                        <i class="fa-regular fa-check"></i>
                                    </button>
                                    <button mat-button color="error" title="Cancel" (click)="cancelEditFooterNote();">
                                        <i class="fa-regular fa-xmark clear-icon"></i>
                                    </button>
                                </div>
                            </mat-form-field>
                        </div>
                    </div>
                </ng-container>
            </div>

        </div>
    </mat-drawer-content>
    <mat-drawer #balancesheetdrawer class="order-2 drawer-from-right prev-right-drawer">
        <div class="toogle-button-block button-block-right">
            <button mat-button class="button-medium-icon toogle-button" (click)="balancesheetdrawer.toggle()"></button>
            <div class="toogle-content">
                <h6 class="title">Preview</h6>
            </div>
        </div>
        <div class="content-block w-100">
            <!-- <div class="balance-sheet-container-aside-body"> -->
            <balance-sheet-preview></balance-sheet-preview>
            <!-- <div class="preview-footer" *ngIf="isHideFooterNotesToFS">
                <div class="bs-footer preview-footer-head">
                  <p class="bs-footer-text">
                    <span> {{footerNotes}}</span>
                  </p>
                  <div *ngIf="false"><br>
                    <span class="pageno">page #</span>
                  </div>
                </div>

              </div> -->
        </div>

    </mat-drawer>
</mat-drawer-container>


<!-- Dailog Box-->
<ng-template #createLeadsheetDialog>
    <div class="create-leadsheet-dialog">
        <div class="dialogboxheader">
            <div class="flex-box header-title elem-p">
                <h1 mat-dialog-title dialogbox class="flex-box no-marg">
                    <span>Create New Lead Sheet</span>
                </h1>
            </div>
            <button class="transparent-btn float-right " [mat-dialog-close]>
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div mat-dialog-content>
            <form autoComplete="off">
                <div class="row no-marg">
                    <mat-form-field class="full-row">
                        <mat-label>Group</mat-label>
                        <mat-select [disableOptionCentering]="true">
                            <mat-option>Assets</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="row no-marg">
                    <mat-form-field class="full-row">
                        <mat-label>Sub Group</mat-label>
                        <mat-select [disableOptionCentering]="true">
                            <mat-option>C - Assets</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="row no-marg">
                    <mat-form-field class="full-row">
                        <mat-label>Lead Sheet Code</mat-label>
                        <mat-select [disableOptionCentering]="true">
                            <mat-option>1001</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="row no-marg">
                    <mat-form-field class="full-row">
                        <input matInput placeholder="Lead Sheet Name">
                    </mat-form-field>
                </div>
            </form>
        </div>
        <div mat-dialog-actions>
            <div class="pd-delete-dialog-actions">
                <button mat-flat-button class="float-right ok-button" [mat-dialog-close]>Add</button>
            </div>
        </div>
    </div>
</ng-template>

<!--Create group-->
<ng-template #creategroup>
    <div class="countable-dialog creategroup" style="width: 600px;">
        <div mat-dialog-title class="dialog-header">
            <h4 class="title">Create Group</h4>
            <button mat-button class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <mat-form-field floatLabel="always" class="fixed-label w-100">
                <mat-label>Group Name</mat-label>
                <input matInput type="text" class="form__input" id="name" placeholder="Group name"
                       [(ngModel)]="groupName"/>

            </mat-form-field>
            <p>Following selected items from existing group will be moved to the new group</p>
            <div class="card flex-table w-100">
                <div class="flex-table-header">
                    <div class="ft-row">
                        <p class="ft-cell" style="width: 44px;max-width:44px;">
                            <mat-checkbox class="label-none" (change)="toggleLineItems($event)"
                                          [checked]="isCheckedAll"></mat-checkbox>
                        </p>
                        <p class="ft-cell" style="width: 250px;max-width:250px;">
                            <span class="text-ellipse">Sub Group Name</span>
                        </p>
                        <p class="ft-cell flex-1">
                            <span class="text-ellipse">LS</span>
                        </p>
                    </div>
                </div>
                <div class="flex-table-body">
                    <div class="ft-row" *ngFor="let ls of selectedTrailBLrow">
                        <p class="ft-cell" style="width: 44px;max-width:44px;">
                            <mat-checkbox class="label-none" [(ngModel)]="ls.checked" (change)="removeChildItem(ls)"
                                          [checked]="ls.checked"></mat-checkbox>
                        </p>
                        <p class="ft-cell" style="width: 250px;max-width:250px;" title="{{ls.accountname}}">
                            <span class="text-ellipse">{{ ls.accountname }}</span>
                        </p>
                        <p class="ft-cell flex-1 overflow-hidden" title="{{ls.leadsheet}}">
                            <span class="text-ellipse">{{ ls.leadsheet }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>

    <div mat-dialog-actions class="dialog-footer button-group">
      <mat-error *ngIf="isManualGroupExists == 1">Cannot create a group as the items selected are already in a custom
        group. Please ungroup the items and try again.</mat-error>
      <button mat-button mat-flat-button class="button-default" color="primary" (click)="createGroup()"
        [disabled]="disabledGroupButton || !groupName || (isManualGroupExists == 1)" [mat-dialog-close]>Create</button>
    </div>
  </div>
</ng-template>

<!--ungroup-->
<ng-template #ungroup>
    <div class="countable-dialog confirmation-dailog ungroupDialog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
            <h4 class="title">Ungroup</h4>
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <p> You are trying to ungroup '<span class="fw-semibold">{{ unGroupName }}</span>',all the line items will
                be moved
                to its parent location.</p>
            <p>Do you want to continue?</p>
        </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]="false">No</button>
      <button mat-button mat-flat-button class="button-default" color="primary" [mat-dialog-close] ="true"
        (click)="unGroup()">Yes</button>
    </div>
  </div>
</ng-template>

<!-- save lead sheet message box -->
<ng-template #saveLeadsheetDialog>
    <div class="countable-dialog confirmation-dailog saveLeadsheetDialog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
            <h4 class="title">Move Lead Sheet</h4>
            <button color="error" class="close" [mat-dialog-close] (click)="clearRowSelection()">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <p>You are trying to move to Lead Sheet <span class="fw-semibold">{{ leadSheetName }}</span>.</p>
            <p>Do you want to continue?</p>
        </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]
        (click)="clearRowSelection()">No</button>
      <button mat-button mat-flat-button class="button-default" color="primary" [mat-dialog-close]
        (click)="saveLeadSheetdetails()">Yes</button>
    </div>
  </div>
</ng-template>

<!--save Map no message box -->
<ng-template #saveMapNoDialog>
    <div class="countable-dialog confirmation-dailog saveMapNoDialog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
            <h4 class="title">Move Map No.</h4>
            <button color="error" class="close" [mat-dialog-close] (click)="clearRowSelection()">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <p>You are trying to move to Map Number <span class="fw-semibold">{{ mapNo }}</span>.</p>
            <p>Do you want to continue?</p>
        </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]
        (click)="clearRowSelection()">No</button>
      <button mat-button mat-flat-button class="button-default" color="primary" [mat-dialog-close]
        (click)="savemappingdetails()">Yes</button>
    </div>
  </div>
</ng-template>


<span class="sort-position position-absolute" [matMenuTriggerFor]="sortmenu" #sortingMenu="matMenuTrigger"></span>

<mat-menu #sortmenu="matMenu" class="sort-menu" xPosition="after" yPosition="below" [hasBackdrop]="false">
    <div class="flexbox-column gap-0 h-100 overflow-hidden" (click)="$event.stopPropagation()">
        <div class="flexbox-row justify-content-between p-2">
            <h4>Sort</h4>
            <button mat-button class="button-text" (click)="closeSort()">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div class="flexbox-row px-2 mb-2 justify-content-between">
            <mat-radio-group class="flexbox-row" aria-label="Select an option" [(ngModel)]="sortGroup">
                <mat-radio-button class="radio-btn" (change)="disableSortBtn(s.value)" [value]="s.value"
                                  *ngFor="let s of sortArray" (change)="onChangeSort($event)"><span>{{ s.name }}</span>
                </mat-radio-button>
            </mat-radio-group>
            <div class="button-group" *ngIf="sortGroup != 'AUTO'">
                <button mat-button class="button-text" (click)="manualSorting('UP')" [disabled]="isDisableUpArrow">
          <span *ngIf="!isDisableUpArrow">
            <i class="fa-regular fa-arrow-up"></i>
          </span>
                    <ng-container *ngIf="isDisableUpArrow">
                        <i class="fa-regular fa-arrow-up text-gray-3"></i>
                    </ng-container>
                </button>
                <button mat-button class="button-text" (click)="manualSorting('DOWN')" [disabled]="isDisableDownArrow">
          <span *ngIf="!isDisableDownArrow">
           <i class="fa-solid fa-arrow-down"></i>
          </span>
                    <ng-container *ngIf="isDisableDownArrow">
                        <i class="fa-solid fa-arrow-down text-gray-3"></i>
                    </ng-container>
                </button>
            </div>
        </div>
        <div class="w-100 flex-table fixed-header flex-1 overflow-auto"
             [ngClass]="{'manualclass':sortGroup == 'MAN','autoclass':sortGroup == 'AUTO'}">
            <div class="flex-table-header">
                <div class="ft-row">
                    <p class="ft-header-cell cell-check" *ngIf="sortGroup == 'MAN'"></p>
                    <p class="ft-header-cell flex-nowrap cell-group-name gap-4 align-items-center">
                        <span>Sub Group</span>
                        <button mat-button class="button-text mt-1" *ngIf="sortGroup == 'AUTO'"
                                (click)="toggleSort('group')">
                            <i class="fa-solid fs-14" [ngClass]="(groupisASC ? 'fa-arrow-down' : 'fa-arrow-up')"></i>
                        </button>
                    </p>
                    <p class="ft-header-cell text-end flex-nowrap cell-sort-value gap-4 align-items-center">
                        <span>Amount</span>
                        <button mat-button class="button-text mt-1" *ngIf="sortGroup == 'AUTO'"
                                (click)="toggleSort('amount')">
                            <i class="fa-solid fs-14" [ngClass]="(amountisASC ? 'fa-arrow-down' : 'fa-arrow-up')"></i>
                        </button>
                    </p>
                </div>
            </div>
            <div class="flex-table-body">
                <div class="ft-row" *ngFor="let sort of sortData">
                    <p class="ft-cell cell-check" *ngIf="sortGroup == 'MAN'">
                        <mat-checkbox class="label-none" [(ngModel)]="sort.checked"
                                      (change)="onChangeAddManualData(sort)"
                                      [disabled]="sortCheckboxLength > 0 ? !sort.checked : sort.checked"></mat-checkbox>
                    </p>
                    <p class="ft-cell cell-group-name" title="{{sort.subgroupname}}">
                        <span class="text-ellipse">{{ sort.subgroupname }}</span>
                    </p>
                    <p class="ft-cell text-end cell-sort-value" title="{{sort.sortvalue}}">
                        <span class="text-ellipse">{{ sort.sortvalue }}</span>
                    </p>
                </div>
            </div>
        </div>

    <div class="button-group p-2 border-top w-100">
      <button mat-button mat-flat-button color="primary" class="button-default flex-1" [disabled]="disableSort"
        (click)="onCLickSaveSorting()">Apply</button>
    </div>
  </div>
</mat-menu>

<!--dialog layout-->

<ng-template #notesFSLinkingDialog>
    <div class="countable-dialog template-block-main right-drawer-dialog max-w-100 w-350 mh-100">
        <div class="dialog-header p-2">
            <h4>Link Notes to Financial Statement </h4>
            <button class="transparent-btn close" aria-label="Close" mat-dialog-close type="button">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div class="dialog-body-content p-0">
            <div class="flexbox-column gap-8 px-2">
                <mat-form-field class="fixed-label w-100" floatLabel="always">
                    <mat-label>Financial Statement Item to Link:</mat-label>
                    <mat-select [(ngModel)]="notesSRc" (ngModelChange)="changednotesLinks()">
                        <ng-container *ngFor="let subgroup of getlinkarray">
                            {{ subgroup.fingroupname }} {{ subgroup.finalamount }}
                            <span *ngFor="let item of subgroup.child">{{ item.finsubgroupname }}
                                {{ item.finalamount }}
                                <mat-option class="ps-3" *ngFor="let option of item.subchild" [value]="option">
                  {{ option.finsubgroupchildname }} {{ option.finalamount }}
                </mat-option>
              </span>
                        </ng-container>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="fixed-label w-100 icon-form-before" floatLabel="always">
                    <mat-label>Select notes to link:</mat-label>
                    <input matInput maxlength="20" id="searchKeyword" name="searchKeyword" [(ngModel)]="searchKeyword"
                           (keyup.backspace)="searchNotes($event.target.value)" type="text"
                           (keyup)="searchNotes($event.target.value)"
                           #searchField placeholder="Search" maxlength="100" autocomplete="off">
                    <span matPrefix>
            <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
          </span>
                </mat-form-field>
                <mat-checkbox [checked]="isSelectAll" [(ngModel)]="isSelectAll"
                              (change)="selectAll($event);disablegreenbutton=false;" id="isSelectAll" name="selectAll">
                    Select all
                </mat-checkbox>
            </div>

            <div class="templates-list h-100">
                <ng-container *ngFor="let category of notes; trackBy: trackByRecords;let i=index">
                    <mat-accordion *ngIf="category.notes" #accordion="matAccordion" multi="true" class="w-100">
                        <mat-expansion-panel [expanded]="category.isExpand" class="level-one1">
                            <mat-expansion-panel-header
                                    [ngClass]="{'checked': category.is_checked == true, 'searchActive': category.highlight}">
                                <mat-panel-title>
                  <span class="title-content" title="{{category.name}}">
                    <mat-checkbox class="label-none" (change)="is_recordChecked(i,'category');disablegreenbutton=false;"
                                  [checked]="category.is_checked" (click)="$event.stopPropagation()"
                                  class="item-checkbox">
                    </mat-checkbox>
                    <span class="togglable-icon">
                      <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                    </span>
                    <span class="item-icon">
                      <img src="assets/images/ui-uplift-icons/global/colored-folder-icon.svg" alt="">
                    </span>
                    <span class="item-title">
                      {{ category.engNoteId }}. {{ category.name }}
                    </span>
                  </span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <ul class="templates-list-items">
                                <li [ngClass]="{'active': note.is_checked == true, 'searchActive': note.highlight}"
                                    *ngFor="let note of category.notes;let j=index">
                                    <mat-checkbox
                                            (change)="is_recordChecked(i,'subcategory',j);disablegreenbutton=false;"
                                            [checked]="note.is_checked" (click)="$event.stopPropagation()"
                                            class="list-item-content">
                    <span class="flexbox-row">
                      <span class="item-icon">
                        <img src="../../../../../assets/images/icons/notes-icon.svg" alt="Toogle">
                      </span>
                      <span class="item-title">
                        <span class="numbering">{{ note.engNoteId }}.</span>
                          {{ note.name }}
                      </span>
                    </span>
                                    </mat-checkbox>
                                </li>
                            </ul>
                        </mat-expansion-panel>
                    </mat-accordion>

                    <ng-container *ngIf="!category.notes">
                        <ul class="templates-list-items">
                            <li title="{{category.engNoteId}}.{{category.name}}"
                                [ngClass]="{'active': category.is_checked == true, 'searchActive': category.highlight}">
                                <mat-checkbox class="list-item-content"
                                              (change)="is_recordChecked(i,'category');disablegreenbutton=false;"
                                              (click)="$event.stopPropagation()"
                                              [checked]="category.is_checked">
                  <span class="flexbox-row gap-8">
                    <span class="item-icon">
                      <img src="/assets/images/icons/notes-icon.svg" alt="Toogle">
                    </span>
                    <span class="item-title">{{ category.engNoteId }}.{{ category.name }}</span>
                  </span>
                                </mat-checkbox>
                            </li>
                        </ul>
                    </ng-container>
                </ng-container>
            </div>
        </div>

        <div class="dialog-footer p-2 border-top">
            <button mat-button mat-flat-button color="primary" class="button-default" *ngIf="!disablegreenbutton"
                    [disabled]="shortCutMenuDetails.isenglock !== 0" (click)="saveLinkNotes()" [mat-dialog-close]>
                Link/Unlink Notes {{ getCheckedNotes().length > 0 ? "(" + getCheckedNotes().length + ")" : '' }}
            </button>
            <button mat-button mat-flat-button color="success" class="button-default"
                    *ngIf="getBalancesheet_Notes_Link_Obj().notes && getBalancesheet_Notes_Link_Obj().notes.length && disablegreenbutton"
                    [disabled]="disablegreenbutton || shortCutMenuDetails.isenglock !== 0" (click)="saveLinkNotes()">
                Linked notes
                {{ getCheckedNotes().length > 0 ? "(" + getCheckedNotes().length + ")" : '' }}
            </button>
        </div>
    </div>
</ng-template>

<!--mat options for schedule view -->
<mat-menu #scheduleOperation="matMenu">
    <button mat-menu-item
            (click)="viewSchedule(selectedSchedule().combined_id)">
            <span class="flexbox-row gap-8">
                <i class="fa-regular fa-eye"></i>
                <span>View</span>
            </span>

    </button>
    <button mat-menu-item (click)="deleteSchedule()">
        <span class="flexbox-row gap-12">
            <i class="fa-regular fa-trash-can fs-16"></i>
            <span>Delete</span>
        </span>

    </button>
</mat-menu>


<ng-template #subGroupChildren let-child2="child2" let-balancesheetData="balancesheetData" let-i="i" let-lastIndex="lastIndex" let-lSgroupchild="lSgroupchild" let-isSubGroup="isSubGroup" >
    <mat-expansion-panel
            [expanded]="isSearchExist ? child2.isexpand : isBalanceSheetExpanded"
            *ngIf="balancesheetData.id!=5" #chapterExpansionPanel
            (mouseenter)="mouseEnterHandler($event, chapterExpansionPanel)"
            (keydown.Space)="$event.stopImmediatePropagation();"
            (opened)="lastIndex ? child2.islastIndex = false:''"
            (closed)="lastIndex ? child2.islastIndex = true:''"
            [ngStyle]="{'border-bottom': lastIndex && child2.islastIndex ? '1px solid #000':''}">
        <mat-expansion-panel-header [ngClass]="{'fourth-header': isSubGroup, 'third-header': !isSubGroup}"
                                    (keydown.Space)="$event.stopImmediatePropagation();">
            <mat-panel-title
                    (keydown.Space)="$event.stopImmediatePropagation();">
                <div class="flex-table-header">
                    <div class="flexbox-row gap-0 flex-1 table-left-section align-items-stretch">
                        <div class="ft-cell col-toogle">
                                      <span class="togglable-icon">
                                        <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                      </span>
                        </div>
                        <p class="ft-cell col-checkbox pe-0">
                            <ng-container
                                    *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookBSCheckboxButtons">
                                <mat-checkbox class="label-none"
                                              disabled>
                                </mat-checkbox>
                            </ng-container>
                            <ng-template
                                    #showWorkBookBSCheckboxButtons>
                                <mat-checkbox class="label-none"
                                              [(ngModel)]="child2.checked"
                                              (ngModelChange)="subGroupCheckChange(child2, lSgroupchild)"
                                              (click)="changePosition($event, 'child2')"
                                              (change)="onChangeMatCheckbox()"></mat-checkbox>
                            </ng-template>
                        </p>
                        <p class="ft-cell col-header-title py-0 px-2 flexbox-row gap-8"
                           (click)="$event.stopPropagation()">
                            <ng-container
                                    *ngIf="!child2.isEditable">
                                        <span class="text-ellipse fw-semibold" title="{{child2.name}}">
                                          {{ child2.name }}
                                        </span>
                                <ng-container
                                        *ngIf="acl?.hasEngViewEdit && !isHideActionsForPY">
                                    <button mat-button
                                            class="button-text hover-action-item"
                                            *ngIf="shortCutMenuDetails.isenglock == 0"
                                            (click)="child2.oldvalue = child2.name;acticeGroup(child2, 'CHILD')">
                                        <i class="fa-regular fa-pen fs-15"></i>
                                    </button>
                                    @if (!child2?.isuseradded) {
                                        @if (child2?.is_schedule_exits) {
                                            @if (!isSubGroup){
                                                <button mat-button
                                                        mat-stroked-button
                                                        color="success"
                                                        class="button-small schedule-success-btn"
                                                        (click)="selectedSchedule.set(child2)"
                                                        [matMenuTriggerFor]="scheduleOperation"
                                                        title="{{ child2?.schedule_name }}">
                                                    <span class="flexbox-row gap-8 overflow-hidden">
                                                        <span class="text-ellipse">{{ child2?.schedule_name }}</span>
                                                        <i class="fa-regular fa-angle-down"></i>
                                                    </span>
                                                </button>
                                            }
                                        } @else if(child2?.trialbal?.length > 0 && child2?.trialbal[0]?.trailbalanceid) {
                                            <button mat-button
                                                    mat-flat-button
                                                    color="secondary"
                                                    [disabled]="shortCutMenuDetails.isenglock != 0 || isAddSchedule()"
                                                    (click)="addSchedule(child2)"
                                                    class="button-small button-hover-left">
                                                <i class="fa-regular fa-plus"></i>Schedule
                                                <span class="hover-label mob-hover-label schedule-label">Add Schedule</span>
                                            </button>
                                        }
                                    }
                                    <ng-container
                                            *ngIf="shortCutMenuDetails.isenglock == 0">
                                        <ng-container
                                                class="ungroup"
                                                *ngIf="child2.isuseradded == 1">
                                            <button mat-button
                                                    class="button-text hover-action-item"
                                                    (click)="openunGroupPopup(child2)">
                                                <i class="fa-regular fa-puzzle fs-15"></i>
                                            </button>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngIf="child2.isEditable">
                                <mat-form-field
                                        class="fixed-label icon-form-after action-2 w-100 form-field-smaller">
                                    <input matInput type="text"
                                           [(ngModel)]="child2.name"
                                           #focusInputField
                                           required>
                                    <div matSuffix
                                         class="actions border-start">
                                        <button mat-button
                                                color="success"
                                                title="Save"
                                                [disabled]="!(child2.name?.trim())"
                                                [ngClass]="[!(child2.name?.trim()) ? 'btn-disabled' : '']"
                                                (click)="child2.isEditable=!child2.isEditable;UpdateBalanceSheet(child2, 'SUBCHILD')">
                                            <i class="fa-regular fa-check"></i>
                                        </button>
                                        <button mat-button
                                                color="error"
                                                title="Cancel"
                                                (click)="child2.isEditable=!child2.isEditable;child2.name=child2.oldvalue;clearGroup()">
                                            <i class="fa-regular fa-xmark clear-icon"></i>
                                        </button>
                                    </div>
                                </mat-form-field>
                            </ng-container>
                        </p>
                    </div>

                    <p class="ft-cell col-leadsheet border-start"></p>
                    <p class="ft-cell col-map"></p>
                    <!-- *ngIf="isHideNotesToFS && selectedYearEnd==accYearEnd" -->
                    <p class="ft-cell col-nfs border-start"
                       *ngIf="isHideNotesToFS">
                        <button mat-button class="button-text"
                                *ngIf="child2.Currbal!='-'"
                                (click)="notesFSLinkingSelectionDialogFunc(child2)">
                            <i class="fa-solid fa-plus text-primary fs-14"></i>
                        </button>
                        <ng-container
                                *ngFor="let notes of child2.notes | sortBy let index = index; let l = count">
                            <button mat-button
                                    class="button-text ms-2"
                                    matTooltip={{notes.notename}}
                                    matTooltipClass="ntfs-tooltip"
                                    (click)="navigateFsNotes('/trial-balance-working-sheet/fs-notes',notes?.engNoteId)">
                                <div class="ls-btn">
                                          <span class="ellipse text-link">
                                            {{ notes.engNoteId }}<span *ngIf="index+1 != l">,</span>
                                          </span>
                                </div>
                            </button>
                        </ng-container>
                    </p>
                    <p class="ft-cell col-current text-end fw-semibold border-start"
                       [ngClass]="{'showcolumns':isDisplayCol}">
                                    <span class="text-ellipse totalValue"
                                          *ngIf="!child2.isexpand || !child2.isHideTotal">
                                      {{ child2.Currbal }}
                                    </span>
                    </p>
                    <ng-container *ngIf="isDisplayCol">
                        <p class="ft-cell col-leadsheet border-start"></p>
                        <p class="ft-cell col-map border-end"></p>
                    </ng-container>
                    <p class="ft-cell col-previous text-end fw-semibold pe-2"
                       *ngIf="isPrevyear"
                       [ngClass]="{'border-start':!isDisplayCol}">
                                    <span class="text-ellipse totalValue"
                                          *ngIf="!child2.isexpand || !child2.isHideTotal">
                                      {{ child2.Prevbal }}
                                    </span>
                    </p>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>


        <!-- sub group child line items start -->
        <div cdkDropList id="{{child2.id}}"
             [cdkDropListConnectedTo]="connectedTo"
             (cdkDropListDropped)="drop($event, child2)"
             [cdkDropListData]="child2.trialbal">
            <div class="ft-row"
                 *ngFor="let child3 of child2.trialbal; trackBy: trackByChild3Records;"
                 cdkDrag [cdkDragData]="child3"
                 (cdkDragStarted)="onDragStarted($event)"
                 (cdkDragEnded)="onDragEnded($event)"
                 [cdkDragDisabled]="!acl?.hasEngViewEdit || selectedTrailBLrow.length > 1 || shortCutMenuDetails.isenglock != 0 || child2.isuseradded == 1 && isHideActionsForPY"
                 cdkDragBoundary=".auto-scroll-container-out"
                 (mouseover)="child3.selected = true"
                 (mouseout)="child3.selected = false"
                 [ngStyle]="{cursor: selectedTrailBLrow.length > 1 || shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit ? 'default': 'grab'}"
                 [ngClass]="{'searchActive': child3?.isexpand ==='true', 'five-header': isSubGroup}">
                <div class="flexbox-row gap-0 flex-1 table-left-section align-items-stretch" >
                    <p class="ft-cell col-status" [ngClass]="{'col-toogle': isSubGroup}" >
                                    <span class="status-badge" [ngClass]="{'bg-error':child3.LSchange == 1}">
                                      <span class="status-badge-label">
                                        <ng-container *ngIf="child3.LSchange == 1">CHG</ng-container>
                                      </span>
                                    </span>
                    </p>
                    <p class="ft-cell col-drag-drop"
                       [ngClass]="{'disabled': child2.isuseradded == 1 && isHideActionsForPY}"
                       [hidden]="shortCutMenuDetails.isenglock != 0">
                        <ng-container *ngIf="acl?.hasEngViewEdit">
                            <button mat-button
                                    class="button-text hover-action-item cursor-grab"
                                    *ngIf="child3.selected && this.selectedTrailBLrow.length < 2">
                                <i class="fa-solid fa-grip-dots-vertical"></i>
                            </button>
                        </ng-container>
                    </p>
                    <p class="ft-cell col-checkbox pe-0">
                        <ng-container
                                *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookBSCheckbox2Buttons">
                            <mat-checkbox class="label-none"
                                          disabled></mat-checkbox>
                        </ng-container>
                        <ng-template
                                #showWorkBookBSCheckbox2Buttons>
                            <mat-checkbox class="label-none"
                                          [(ngModel)]="child3.checked"
                                          (ngModelChange)="checkChange(child3,child2, lSgroupchild.id, balancesheetData)"
                                          [checked]="child3.checked"
                                          (click)="changePosition($event, child3)"
                                          (change)="onChangeMatCheckbox()">
                            </mat-checkbox>
                            <span class="test"
                                  style="position: absolute;"
                                  [matMenuTriggerFor]="lsmapdropdown"
                                  #multipleMoveMenu="matMenuTrigger">
                                      </span>
                            <mat-menu #lsmapdropdown="matMenu"
                                      xPosition="after"
                                      yPosition="below"
                                      class="max-w-initial"
                                      [hasBackdrop]="false">
                                <div class="flexbox-row h-100 overflow-hidden gap-0"
                                     (click)="$event.stopPropagation()"
                                     (keydown.tab)="$event.stopPropagation()"
                                     (keydown.shift.tab)="$event.stopPropagation()"
                                     tabindex="-1">
                                    <div class="ls-left-sec h-100 overflow-hidden"
                                         style="width: 380px;">
                                        <button mat-menu-item
                                                class="w-100 p-1"
                                                [ngStyle]="{'background': activeLsMove ? 'rgba(0, 0, 0, 0.04)' : ''}"
                                                [disabled]="leadsheetdisable"
                                                (click)="activeMultiLs(child3, $event)">
                                              <span class="flexbox-row gap-8 justify-content-between">
                                                <span class="button-label fs-16 fw-medium">Modify Leadsheet</span>
                                                <i class="fa-regular fa-angle-right ms-auto text-primary fs-20"></i>
                                              </span>
                                        </button>
                                        <button mat-menu-item
                                                class="w-100 p-1"
                                                [ngStyle]="{'background': activeMapMove ? 'rgba(0, 0, 0, 0.04)' : ''}"
                                                (click)="activeMultiMapNo(child3, $event)">
                                              <span class="flexbox-row gap-8 justify-content-between">
                                                <span class="button-label fs-16 fw-medium">Modify Map No.</span>
                                                <i class="fa-regular fa-angle-right ms-auto text-primary fs-20"></i>
                                              </span>
                                        </button>
                                        <div class="button-group w-100 p-3">
                                            <button mat-button
                                                    mat-stroked-button
                                                    color="dark"
                                                    class="button-medium flex-1"
                                                    [disabled]="(disableAddGroupButton || leadsheetdisable || isHideActionsForPY)"
                                                    (click)="openGroupPopup()">
                                                <span class="button-label d-flex gap-8 align-items-center"><i class="fa-regular fa-layer-plus fs-16"></i>Create Group</span>
                                            </button>
                                            <button mat-button
                                                    mat-stroked-button
                                                    color="dark"
                                                    [disabled]="!selectedSubGroup()?.disableCreateButtons"
                                                    class="button-medium"
                                                    (click)="createSchedule()">
                                                <span class="button-label d-flex gap-8 align-items-center"><i
                                                        class="fa-regular fa-object-ungroup fs-16"></i>Create
                                                  Schedule</span>
                                            </button>
                                        </div>
                                    </div>
                                    <!-- Mutiple leadsheet moving through LS AND MAP NO. start -->
                                    <ng-container
                                            *ngIf="activeLsMove || activeMapMove">
                                        <div class="ls-menu flexbox-column gap-0 h-100 overflow-hidden border-start">
                                            <div class="button-group justify-content-end px-2 pt-2">
                                                <button mat-icon-button
                                                        class="button-text"
                                                        (click)="clearSelection()">
                                                    <i class="fa-regular fa-xmark"></i>
                                                </button>
                                            </div>
                                            <div class="map-section-right overflow-auto h-100">
                                                <!--Latest LS to move-->
                                                <ng-container
                                                        *ngIf="child3.isLeadSheet && activeLsMove">
                                                    <ls-dropdown
                                                            [TbLeadSheetId]="TbLeadSheetId"
                                                            [parentObject]="child3"
                                                            [moveType]="'MULTI'"
                                                            [subscribeFrom]="'BS'"></ls-dropdown>
                                                </ng-container>
                                                <!--Latest MAP NO move-->
                                                <ng-container
                                                        *ngIf="child3.isMap && activeMapMove">
                                                    <map-dropdown
                                                            [tbMapsheetId]="tbMapSheetId"
                                                            [parentObject]="child3"
                                                            [moveType]="'MULTI'"
                                                            [yearEnd]="selectedYearEnd"
                                                            [subscribeFrom]="'BS'"></map-dropdown>
                                                </ng-container>
                                            </div>

                                            <div class="flexbox-row gap-16 p-2 border-top justify-content-end"
                                                 *ngIf="hideMoveButton">
                                                <button mat-button
                                                        mat-flat-button
                                                        class="button-medium"
                                                        color="primary"
                                                        [disabled]="isDisableMoveButton"
                                                        (click)="activeLsMove ? saveLeadSheetdetails():savemappingdetails()">
                                                    Move
                                                </button>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </mat-menu>
                        </ng-template>
                    </p>
                    <p class="ft-cell col-group flex-1"
                       title="{{child3.accountname}}">
                        <span class="text-ellipse">{{ child3.accountname }}</span>
                    </p>
                </div>


                <p class="ft-cell col-leadsheet border-start">
                    <ng-container
                            *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookBSLSButtons">
                                    <span title="{{child3.leadsheet}}" class="text-ellipse d-block">
                                      {{ child3.leadsheet }}
                                    </span>
                    </ng-container>

                    <ng-template #showWorkBookBSLSButtons>
                        <button mat-button
                                title="{{child3.leadsheet}}"
                                [matMenuTriggerFor]="gidLeadeShaeetItems"
                                class="button-text text-start w-100"
                                (click)="activeLSDropdown(child3)"
                                [disabled]="!isindividualRowSave">
                            <span class="text-ellipse text-link">{{ child3.leadsheet }}</span>
                            <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                        </button>
                        <!-- <span [matMenuTriggerFor]="gidLeadeShaeetItems" #lsChild3Menu="matMenuTrigger"></span> -->
                        <!-- [hasBackdrop] ="false" for when clicking on outside menu not closed -->
                        <mat-menu #gidLeadeShaeetItems="matMenu"
                                  class="ls-menu" xPosition="before"
                                  yPosition="below">
                            <!-- latest LS dropdown changes current year -->
                            <ng-container
                                    *ngIf="child3.isLeadSheet && isindividualRowSave">
                                <ls-dropdown
                                        [TbLeadSheetId]="TbLeadSheetId"
                                        [parentObject]="child3"
                                        [moveType]="'SINGLE'"
                                        [yearType]="'CURRENT'"
                                        [subscribeFrom]="'BS'">
                                </ls-dropdown>
                            </ng-container>
                        </mat-menu>
                    </ng-template>
                </p>
                <p class="ft-cell col-map">
                    <ng-container
                            *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookMapNumButtons">
                                    <span title="{{child3.mapname ? child3.mapname : '-'}}"
                                          class="text-ellipse d-block">
                                      {{ child3.mapno }}
                                    </span>
                    </ng-container>
                    <ng-template #showWorkBookMapNumButtons>
                        <button mat-button
                                class="button-text text-start w-100"
                                title="{{child3.mapname ? child3.mapname : '-'}}"
                                [matMenuTriggerFor]="gridMapNumDropDown"
                                (click)="mappingNumber(child3, 'current')"
                                [disabled]="!isindividualRowSave">
                            <span class="text-ellipse text-link">{{ child3.mapno }}</span>
                            <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                        </button>
                        <span [matMenuTriggerFor]="gridMapNumDropDown"
                              #mapChild3Menu="matMenuTrigger"></span>
                        <mat-menu #gridMapNumDropDown="matMenu"
                                  class="map-menu"
                                  xPosition="before"
                                  yPosition="below">
                            <!-- latest mapno dropdown chnage current year -->
                            <ng-container
                                    *ngIf="child3.isMap && isindividualRowSave">
                                <map-dropdown
                                        [tbMapsheetId]="tbMapSheetId"
                                        [parentObject]="child3"
                                        [moveType]="'SINGLE'"
                                        [yearType]="'CURRENT'"
                                        [yearEnd]="selectedYearEnd"
                                        [subscribeFrom]="'BS'"></map-dropdown>
                            </ng-container>
                        </mat-menu>
                    </ng-template>
                </p>
                <p class="ft-cell col-nfs border-start"
                   *ngIf="isHideNotesToFS">
                    <!-- <button class="text-link">-</button> -->
                </p>
                <p class="ft-cell col-current text-end border-start"
                   title="{{child3.Currbal}}">
                    <span>{{ child3.Currbal }}</span>
                </p>
                <!-- Previous year LS and Map no start -->
                <ng-container *ngIf="isDisplayCol">
                    <p class="ft-cell col-leadsheet border-start"
                       [ngClass]="{'flex-center': !child3.prevleadsheet}"
                       title="{{child3.prevleadsheet ? child3.prevleadsheet : '-'}}">
                        <ng-container
                                *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookPreLSButtons">
                                      <span class="text-ellipse">
                                        {{ child3.prevleadsheet ? child3.prevleadsheet : '-' }}
                                      </span>
                        </ng-container>
                        <ng-template #showWorkBookPreLSButtons>
                            <ng-container
                                    *ngIf="child3.prevmapsheetid != null else withoutMenu">
                                <button mat-button
                                        class="button-text text-start w-100"
                                        [matMenuTriggerFor]="previousYearsId"
                                        (click)="activePreviousYearLSDropdown(child3)"
                                        [disabled]="!isindividualRowSave">
                                          <span class="text-ellipse">
                                            {{ child3.prevleadsheet ? child3.prevleadsheet : '-' }}
                                          </span>
                                    <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                                </button>
                                <mat-menu #previousYearsId="matMenu"
                                          class="ls-menu"
                                          #beforeMenu="matMenu"
                                          xPosition="before">
                                    <!--latest LS dropdown changes previous year-->
                                    <ng-container
                                            *ngIf="child3.isLeadSheet && isindividualRowSave">
                                        <ls-dropdown
                                                [TbLeadSheetId]="TbLeadSheetId"
                                                [parentObject]="child3"
                                                [moveType]="'SINGLE'"
                                                [yearType]="'PREVIOUS'"
                                                [subscribeFrom]="'BS'">
                                        </ls-dropdown>
                                    </ng-container>
                                </mat-menu>
                            </ng-container>
                            <ng-template #withoutMenu>
                                <div class="ls-btn"
                                     style="cursor: default;">
                                          <span class="ellipse">{{
                                                  child3.prevleadsheet ? child3.prevleadsheet :
                                                          '-'
                                              }}</span>
                                </div>
                            </ng-template>
                        </ng-template>
                    </p>
                    <p class="ft-cell col-map border-end"
                       title="{{child3.mapname ? child3.mapname : '-'}}">
                        <ng-container
                                *ngIf="shortCutMenuDetails.isenglock != 0 || !acl?.hasEngViewEdit else showWorkBookPreMapNumButtons">
                                      <span title="{{child3.mapname ? child3.mapname : '-'}}"
                                            class="text-ellipse d-block">
                                        {{ child3.prevmapno ? child3.prevmapno : '-' }}
                                      </span>
                        </ng-container>
                        <ng-template #showWorkBookPreMapNumButtons>
                            <button mat-button
                                    class="button-text text-start w-100"
                                    [matMenuTriggerFor]="gridMapNumDropDown"
                                    (click)="mappingNumber(child3,  'previous')"
                                    [ngClass]="{'flex-center': !child3.prevmapno}"
                                    [disabled]="!isindividualRowSave">
                                <span class="text-ellipse">{{ child3.prevmapno ? child3.prevmapno : '-' }}</span>
                                <i class="fa-solid fa-angle-down fs-15 hover-action-item"></i>
                            </button>
                            <mat-menu #gridMapNumDropDown="matMenu"
                                      class="map-menu"
                                      #beforeMenu="matMenu"
                                      xPosition="before">
                                <!-- latest mapno dropdown chnage previous year -->
                                <ng-container
                                        *ngIf="child3.isMap && isindividualRowSave">
                                    <map-dropdown
                                            [tbMapsheetId]="tbMapSheetId"
                                            [parentObject]="child3"
                                            [moveType]="'SINGLE'"
                                            [yearType]="'PREVIOUS'"
                                            [yearEnd]="selectedYearEnd"
                                            [subscribeFrom]="'BS'"></map-dropdown>
                                </ng-container>
                            </mat-menu>
                        </ng-template>
                    </p>
                </ng-container>

                <p class="ft-cell col-previous text-end"
                   *ngIf="isPrevyear"
                   [ngClass]="{'border-start':!isDisplayCol}">
                    <span title="{{child3.Prevbal}}">{{ child3.Prevbal }}</span>
                </p>
            </div>
        </div>
        <!-- sub group child line items end -->
        <div class="ft-row">
            <div class="flexbox-row gap-0 flex-1 table-left-section align-items-stretch">
                <p class="ft-cell col-status"></p>
                <p class="ft-cell col-drag-drop"></p>
                <p class="ft-cell col-checkbox pe-0"></p>
                <p class="ft-cell col-header-title py-0 flex-nowrap flexbox-row gap-8"
                   (click)="$event.stopPropagation()">
                                  <span class="text-ellipse fw-semibold" title="{{child2.totalname}}">
                                    {{ child2.totalname }}
                                  </span>
                </p>
            </div>
            <p class="ft-cell col-leadsheet border-start"></p>
            <p class="ft-cell col-map"></p>
            <p class="ft-cell col-nfs border-start"
               *ngIf="isHideNotesToFS"></p>
            <p class="ft-cell col-current text-end fw-semibold border-start"
               [ngClass]="{'showcolumns':isDisplayCol}">
                                <span class="text-ellipse" *ngIf="!child2.isexpand || !child2.isHideTotal">
                                  {{ child2.Currbal }}
                                </span>
            </p>
            <ng-container *ngIf="isDisplayCol">
                <p class="ft-cell col-leadsheet border-start"></p>
                <p class="ft-cell col-map border-end"></p>
            </ng-container>
            <p class="ft-cell col-previous text-end fw-semibold pe-2"
               title="{{child2.Prevbal}}"
               *ngIf="isPrevyear"
               [ngClass]="{'border-start':!isDisplayCol}">
                                <span class="text-ellipse" *ngIf="!child2.isexpand || !child2.isHideTotal">
                                  {{ child2.Prevbal }}
                                </span>
            </p>
        </div>
        <!-- Sub child group total end -->
    </mat-expansion-panel>
</ng-template>
